import React, { useContext, useState, useEffect } from "react";
import styled from "styled-components";
import AppContext from "../../context/context";

// mui-components
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import TickIcon from "@mui/icons-material/CheckOutlined";
import CrossIcon from "@mui/icons-material/ClearOutlined";

// components
import UtilDiv from "../../components/Utildiv";
import CreateNewUser from "../../components/User/Createuser";
import Nodata from "../../components/Nodata";
import { TableContainerStyled, TableCellStyled, Table, TableBody, TableRow } from "../../components/TableComponents";
import WarningModal from "../../components/Warningmodal";
import EditUser from "../../components/User/Edituser";
import { DeleteIconButton, EditIconButton } from "../../components/ButtonIcons";

// services
import {
  getAllUsers,
  deleteUser,
} from "../../service/user.service";
import Actions from "../../context/actions";
import Stack from "@mui/material/Stack";
import UsersPreloader from "../../components/Preloaders/UsersPreloader";

//utils
import AdminUtil from "../../utils/admin.util";
import Constants from "../../constants";

// styled
const UsersListDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex-wrap: wrap;
`;

const Users = () => {
  // store variabled
  const { store, dispatch } = useContext(AppContext);
  const { user } = store;

  // stat variabled
  const [_users, setUsers] = useState([]);
  const [_opencreate, setOpencreate] = useState(false);
  const [_loading, setLoading] = useState(false);
  const [_openedit, setOpenedit] = useState(false);
  const [_opendelete, setOpendelete] = useState(false);
  const [_selectedUser, setSelectedUser] = useState({});

  const _loadUsers = async () => {
    setLoading(true);
    let usrs = await getAllUsers(user);
    dispatch({
      type: Actions.SET_USER_LIST,
      payload: usrs,
    });
    setUsers(usrs);
    setLoading(false);
  };

  // const _changeAdminStatus = async (_u) => {
  //   const us = await promoteDemoteAdmin(_u);
  //   if (us === "success") {
  //     _loadUsers();
  //   }
  // };

  const _deleteUser = async (_u) => {
    setLoading(true);
    await deleteUser(user, _u);
    setOpendelete(false);
    _loadUsers();
  };

  const _handleEdit = async (_u) => {
    setSelectedUser(_u);
    setTimeout(() => {
      setOpenedit(true);
    }, 100)
  }

  const _handleDelete = async (_u) => {
    setSelectedUser(_u);
    setTimeout(() => {
      setOpendelete(true);
    }, 100)
  }

  useEffect(() => {
    _loadUsers();
    //eslint-disable-next-line
  }, [user["id"]]);


  if (_loading) {
    return <UsersPreloader />
  }

  return (
    <div>
      <UtilDiv>
        <Stack direction="row" alignItems="center" spacing={2}>

        </Stack>
        <Button
          disableElevation
          // sx={{ marginLeft: "16px" }}
          size="small"
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setOpencreate(true)}
        >
          New User
        </Button>
      </UtilDiv>
      {_users.length === 0 ? (
        <Nodata message={"You have not created users yet."} />
      ) : (
        <UsersListDiv>
          <TableContainerStyled>
            <Table aria-label="channel-list">
              <TableRow>
                <TableCellStyled align="left">No</TableCellStyled>
                <TableCellStyled align="left">Name/Email</TableCellStyled>
                <TableCellStyled align="left">Admin</TableCellStyled>
                <TableCellStyled align="left">Channel Limit</TableCellStyled>
                <TableCellStyled align="left">Domains</TableCellStyled>
                {
                  AdminUtil.isSuperAdmin(user) && <TableCellStyled align="left">More</TableCellStyled>
                }

              </TableRow>
              <TableBody>
                {_users.map((itrUser, index) => {
                  const totalChannels = itrUser?.domains?.reduce((tot, d) => tot + d["channel_limit"], 0);
                  return (
                    <TableRow key={itrUser.name + " " + index}>
                      <TableCellStyled align="left">{index + 1}</TableCellStyled>
                      <TableCellStyled align="left">{itrUser.username}</TableCellStyled>
                      <TableCellStyled align="left">{
                        itrUser?.type === Constants.user_type.USER ? (<CrossIcon
                          sx={{
                            width: 18,
                            height: 18,
                            cursor: "pointer",
                            color: "red",
                          }}
                        />) :
                          (<TickIcon
                            sx={{
                              width: 18,
                              height: 18,
                              cursor: "pointer",
                              color: "green",
                            }}
                          />)}
                      </TableCellStyled>
                      <TableCellStyled align="left">{totalChannels}</TableCellStyled>
                      <TableCellStyled align="left">
                        {
                          itrUser?.domains?.map(domain => {
                            return <p>{domain.name} : {domain["channel_limit"]}</p>
                          })
                        }
                      </TableCellStyled>
                      <TableCellStyled align="left">
                        {
                          AdminUtil.isSuperAdmin(user) && <Stack direction="row" spacing={2} alignItems="center" sx={{ marginTop: "8px" }} >
                            <EditIconButton onClick={() => _handleEdit(itrUser)} color="primary" />
                            <DeleteIconButton onClick={() => _handleDelete(itrUser)} color="error" />
                          </Stack>
                        }
                      </TableCellStyled>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainerStyled>
        </UsersListDiv>
      )}

      <CreateNewUser
        open={_opencreate}
        onClose={() => setOpencreate(false)}
        callback={() => _loadUsers()}
      />
      <EditUser
        open={_openedit}
        onClose={() => setOpenedit(false)}
        userToEdit={_selectedUser}
        callback={() => _loadUsers()}
      />
      <WarningModal
        open={_opendelete}
        onClose={() => setOpendelete(false)}
        message={`You sure you want to delete the user ${_selectedUser?.username} ?`}
        onYes={() => _deleteUser(_selectedUser)}
      />
    </div>
  );
};

export default Users;
